import { Link } from "react-router-dom";
import { Lock, MessageCircle } from "lucide-react";

export default function Footer({ t, onContact }) {
  return (
    <footer
      data-testid="main-footer"
      className="relative overflow-hidden border-t border-white/[0.06] bg-[#06080C] pt-20"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <p className="text-center text-sm italic text-slate-400">
          {t.footer.claim}
        </p>
        <h2
          data-testid="footer-brand"
          className="th-text-outline mt-6 select-none text-center font-display text-[16vw] font-black uppercase leading-none tracking-tight lg:text-[11rem]"
        >
          Talent Hub
        </h2>
        <div className="mt-4 flex flex-col items-center justify-between gap-6 border-t border-white/[0.06] py-8 sm:flex-row">
          <button
            data-testid="footer-contact-button"
            type="button"
            onClick={onContact}
            className="inline-flex items-center gap-2 font-mono text-sm text-[#00F562] transition-opacity duration-300 hover:opacity-80"
          >
            <MessageCircle size={14} />
            {t.chat.floatingLabel}
          </button>
          <div className="flex items-center gap-6">
            <a
              data-testid="footer-privacy-link"
              href="#"
              className="text-xs uppercase tracking-widest text-slate-500 transition-colors duration-300 hover:text-white"
            >
              {t.footer.privacy}
            </a>
            <a
              data-testid="footer-terms-link"
              href="#"
              className="text-xs uppercase tracking-widest text-slate-500 transition-colors duration-300 hover:text-white"
            >
              {t.footer.terms}
            </a>
            <Link
              data-testid="footer-admin-link"
              to="/admin"
              className="flex items-center gap-1.5 text-xs uppercase tracking-widest text-slate-500 transition-colors duration-300 hover:text-[#00F562]"
            >
              <Lock size={11} />
              {t.footer.admin}
            </Link>
          </div>
          <p className="font-mono text-[11px] text-slate-600">
            {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
}
